import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBalanceScale, faExclamationTriangle, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import InternalShell, { useInternalApi } from '../layouts/InternalShell';
import { FINANCE_NAV } from './nav';

interface Day { date: string; internal_total: number; gateway_total: number; difference: number; matches: boolean; }

const Reconciliation: React.FC = () => {
    const { api } = useInternalApi();
    const [days, setDays] = useState<Day[]>([]);
    const [mismatched, setMismatched] = useState(0);
    const [loading, setLoading] = useState(true);

    useEffect(() => { document.title = 'Reconciliation - Uzima Internal'; }, []);
    useEffect(() => {
        api.get('admin-dashboard/finance/reconciliation/').then(res => {
            if (res.data?.status === 'success') {
                setDays(res.data.data.days || []);
                setMismatched(res.data.data.mismatched_days || 0);
            }
        }).finally(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <InternalShell activeDashboard="finance_center" subNav={FINANCE_NAV}>
            <h2 className="fw-bold mb-1"><FontAwesomeIcon icon={faBalanceScale} className="me-2 text-primary" />Reconciliation</h2>
            <p className="text-muted mb-4">Internally-recorded payments vs. gateway-reported totals, day by day, over the last 30 days</p>

            {loading ? (
                <div className="text-center py-5"><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div></div>
            ) : (
                <>
                    {mismatched > 0 ? (
                        <div className="alert alert-warning"><FontAwesomeIcon icon={faExclamationTriangle} className="me-2" /><strong>{mismatched} day(s)</strong> where internal and gateway totals don't match.</div>
                    ) : (
                        <div className="alert alert-success"><FontAwesomeIcon icon={faCheckCircle} className="me-2" />All days in range reconcile cleanly.</div>
                    )}

                    <div className="card border-0 shadow-sm">
                        <div className="card-body p-0">
                            {days.length === 0 ? (
                                <div className="text-center py-5 text-muted">No financial activity in the last 30 days to reconcile.</div>
                            ) : (
                                <table className="table table-hover align-middle mb-0">
                                    <thead className="table-light"><tr><th>Date</th><th>Internal Total</th><th>Gateway Total</th><th>Difference</th><th>Status</th></tr></thead>
                                    <tbody>
                                        {days.map(d => (
                                            <tr key={d.date} className={!d.matches ? 'table-warning' : ''}>
                                                <td>{d.date}</td>
                                                <td>{d.internal_total.toLocaleString()}</td>
                                                <td>{d.gateway_total.toLocaleString()}</td>
                                                <td>{d.difference.toLocaleString()}</td>
                                                <td>{d.matches ? <span className="badge bg-success">Matches</span> : <span className="badge bg-warning">Review</span>}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </>
            )}
        </InternalShell>
    );
};

export default Reconciliation;
